











import { ContactDetailsApi } from "@/api";
import stateMixin from "@/mixins/state";
import DOMPurify from "dompurify";

export default {
  data() {
    return {
      data: null,
      htmlData: "",
      emailStartTag: "[email]",
      emailCloseTag: "[/email]"
    };
  },
  name: "Contact",
  mixins: [stateMixin],
  mounted() {
    this.fetch();
  },
  methods: {
    fetch: async function() {
      this.setState(this.states.LOADING);
      try {
        const api = new ContactDetailsApi();
        const { data } = await api.contactDetailsGet();
        this.data = (data as unknown) as null;

        // Format the data as html so <a href=></a> can be added.
        this.formatData((this.data as unknown) as string);
        this.htmlData = this.sanitizeData(this.htmlData);
        this.setState(this.states.INITIAL);
      } catch {
        this.setState(this.states.ERROR);
      }
    },
    /**  Format the inputdata to use `<a href=></a>` in place of `[email]` and `[/email]`
     *  Checks if amount of opening tags is equal to closing tags. If not return input as is.
     *
     */
    formatData: function(input: string) {
      var startTagIndexes = this.indexOfAll(input, this.emailStartTag);
      var endTagIndexes = this.indexOfAll(input, this.emailCloseTag);

      // Check if there are custom tags.
      // Return the input directly if mismatch between opening and closing tags.
      if (
        startTagIndexes.length > 0 &&
        startTagIndexes.length !== endTagIndexes.length
      ) {
        this.htmlData = input;
        return;
      }

      this.htmlData = input;

      var startTagIndexToCheck = startTagIndexes[0];
      var endTagIndexToCheck = endTagIndexes[0];

      for (let i = 0; i < startTagIndexes.length; i++) {
        // Get emailAddress between tags
        var emailAddress = this.getStringBetweenIndexes(
          startTagIndexToCheck,
          endTagIndexToCheck
        );

        this.replaceCustomTagsWithHref(
          startTagIndexToCheck,
          endTagIndexToCheck,
          emailAddress
        );

        // since html is updated, indexes do not match anymore, update next pair of indexes in case there are.
        if (startTagIndexes.at(i + 1) !== -1) {
          startTagIndexToCheck = this.htmlData.indexOf(this.emailStartTag);
          endTagIndexToCheck = this.htmlData.indexOf(this.emailCloseTag);
        }
      }
      return;
    },
    getStringBetweenIndexes: function(
      startIndex: number,
      endIndex: number
    ): string {
      var email = this.htmlData
        .substring(startIndex + this.emailStartTag.length, endIndex)
        .trim();
      return email;
    },
    /**  replace the start of the custom tag to the end of a custom tag with:
     *  `<a href="mailto:${emailAddress}"> ${emailAddress}</a>`
     */
    replaceCustomTagsWithHref: function(
      startIndex: number,
      endindex: number,
      emailAddress: string
    ) {
      var htmlString = `<a href="mailto:${emailAddress}">${emailAddress}</a>`;

      this.htmlData = this.htmlData.replace(
        this.htmlData.substring(
          startIndex,
          endindex + this.emailCloseTag.length
        ),
        htmlString
      );
    },
    indexOfAll: function(inputString: string, searchItem: string): number[] {
      var index = inputString.indexOf(searchItem),
        indexes = [];
      while (index !== -1) {
        indexes.push(index);
        index = inputString.indexOf(searchItem, ++index);
      }
      return indexes;
    },
    sanitizeData: function(data: string) {
      return DOMPurify.sanitize(data, { USE_PROFILES: { html: true } });
    }
  }
};
